import cornerstoneTools from 'cornerstone-tools';
import cornerstone from 'cornerstone-core';
const draw = cornerstoneTools.importInternal('drawing/draw');
const setShadow = cornerstoneTools.importInternal('drawing/setShadow');
const getNewContext = cornerstoneTools.import('drawing/getNewContext');
const getPixelSpacing = cornerstoneTools.importInternal('util/getPixelSpacing');
const drawHandles = cornerstoneTools.import('drawing/drawHandles')
const getROITextBoxCoords = cornerstoneTools.importInternal('util/getROITextBoxCoords');
const numbersWithCommas = cornerstoneTools.importInternal('util/numbersWithCommas');
const drawLinkedTextBox = cornerstoneTools.importInternal('drawing/drawLinkedTextBox');
const rectangleRoiCursor = cornerstoneTools.importInternal('cursors/index');
const EllipticalRoiTool = cornerstoneTools.EllipticalRoiTool;

export default class GridToolEyonix extends EllipticalRoiTool {
    imgA;
    imgB;
    imgC;
    constructor(props = {}) {

        const defaultProps = {
            name: 'GridABCTool',
            supportedInteractionTypes: ['Mouse', 'Touch'],
            configuration: {
                drawHandles: true,
                drawHandlesOnHover: false,
                hideHandlesIfMoving: false,
                renderDashed: false,
                // showMinMax: false,
                // showHounsfieldUnits: true
            },
            svgCursor: rectangleRoiCursor,
        };

        super(defaultProps);

        this.imgA = new Image();
        this.imgA.src = '/image/gridEyonix/grid_A.png';

        this.imgB = new Image();
        this.imgB.src = '/image/gridEyonix/grid_B.png';

        this.imgC = new Image();
        this.imgC.src = '/image/gridEyonix/grid_C.png';

    }

    createNewMeasurement(eventData) {
        const goodEventData = eventData && eventData.currentPoints && eventData.currentPoints.image;
        const toolData = cornerstoneTools.getToolState(eventData.element, this.name);

        if (!goodEventData) {
            return;
        }

        if(toolData && toolData.data.length > 0) {
            return;
        }

        return {
            visible: true,
            active: true,
            color: undefined,
            fontSize: undefined,
            textVisible: undefined,
            invalidated: true,
            who: undefined,
            when: undefined,
            whenStr: undefined,
            initialRotation: eventData.viewport.rotation,
            handles: {
                start: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: false,
                    //hasBoundingBox: true,
                },
                end: {
                    x: eventData.currentPoints.image.x,
                    y: eventData.currentPoints.image.y,
                    highlight: true,
                    active: true,
                },
                initialRotation: eventData.viewport.rotation,
                textBox: {
                    active: false,
                    hasMoved: false,
                    movesIndependently: false,
                    drawnIndependently: true,
                    allowedOutsideImage: true,
                    hasBoundingBox: true,
                },
            },
        };
    }

    renderToolData(evt) {
        const toolData = cornerstoneTools.getToolState(evt.currentTarget, this.name);


        if (!toolData) {
            return;
        }

        const eventData = evt.detail;
        const viewport = cornerstone.getViewport(eventData.element);
        const { image, element } = eventData;
        const lineWidth = cornerstoneTools.toolStyle.getToolWidth();
        const lineDash = cornerstoneTools.getModule('globalConfiguration').configuration.lineDash;
        const {
            handleRadius,
            drawHandlesOnHover,
            hideHandlesIfMoving,
            renderDashed,
        } = this.configuration;
        const context = getNewContext(eventData.canvasContext.canvas);
        const { rowPixelSpacing, colPixelSpacing } = getPixelSpacing(image);

        // Meta
        const seriesModule =
            window.cornerstone.metaData.get('generalSeriesModule', image.imageId) ||
            {};

       // const hideHandlers = eventData.viewport.hideHanders || false;

        // Pixel Spacing
        const modality = seriesModule.modality;
        const hasPixelSpacing = rowPixelSpacing && colPixelSpacing;

        let initFontSize = cornerstoneTools.textStyle.getFontSize();


        draw(context, context => {
            // If we have tool data for this element - iterate over each set and draw it
            for (let i = 0; i < toolData.data.length; i++) {
                const data = toolData.data[i];

                if (data.visible === false) {
                    continue;
                }

                // Configure
                var color = cornerstoneTools.toolColors.getColorIfActive(data);
                color = color.hasOwnProperty('main')? color['main']: color;

                data.color = data.color || cornerstoneTools.toolColors.getToolColor(data);


                data.fontSize = data.fontSize !== undefined? data.fontSize : cornerstoneTools.textStyle.getFontSize();
                data.textVisible = data.textVisible !== undefined? data.textVisible : this.options.annotationTextVisible;
                data.gridType = data.gridType !== undefined? data.gridType : this.options.gridType;

                cornerstoneTools.textStyle.setFont(`${data.fontSize}px Roboto`);
                cornerstoneTools.textStyle.setFontSize(data.fontSize);

                if(data.invalidated && (data.who !== this.initialConfiguration.user || data.when !== new Date().toLocaleString())) {
                    data.who = this.initialConfiguration.user;
                    data.when = new Date().toLocaleString();
                    if(this.initialConfiguration.momentLib && this.initialConfiguration.defaultDateTimeFormat) {
                        data.whenStr = this.initialConfiguration.momentLib().format(this.initialConfiguration.defaultDateTimeFormat);
                    } else {
                        data.whenStr = new Date().toLocaleString();
                    }
                }

                const handleOptions = {
                    color,
                    handleRadius,
                    drawHandlesIfActive: drawHandlesOnHover,
                    hideHandlesIfMoving,
                };

                setShadow(context, this.configuration);

                const rectOptions = { color };

                function getCanvasPoint(startX, startY) {
                    return window.cornerstone.pixelToCanvas(element, {x: startX, y: startY})
                }

                let pointStart = getCanvasPoint(data.handles.start.x, data.handles.start.y);
                let pointEnd = getCanvasPoint(data.handles.end.x, data.handles.end.y);

                let diff = Math.abs(data.handles.end.x - data.handles.start.x);

                //data.handles.end.y = data.handles.start.y + diff;

                let img;
                switch (data.gridType){
                    case "A":
                        img = this.imgA;
                        break;
                    case "B":
                        img = this.imgB;
                        break;
                    case "C":
                        img = this.imgC;
                        break;
                    default:
                        img = this.imgA;
                        break;
                }

                const rotation = viewport.rotation;
                const initRot = data.initialRotation || 0;

                let deg =  (rotation - initRot) * (Math.PI/180);
                if(rotation === initRot) {
                    deg = 0;
                }
                context.save();
                context.translate(pointStart.x, pointStart.y);
                context.rotate(deg);

                context.drawImage(img, 0, 0,
                    Math.abs(pointEnd.x - pointStart.x),
                    Math.abs(pointEnd.x - pointStart.x),
                );

                context.restore();

                if (renderDashed) {
                    rectOptions.lineDash = lineDash;
                }

                if (data.active) {
                    drawHandles(context, eventData, data.handles, handleOptions);
                }

                // Update textbox stats
                if (data.invalidated === true) {
                    if (data.cachedStats) {
                        this.throttledUpdateCachedStats(image, element, data);
                    } else {
                        this.updateCachedStats(image, element, data);
                    }
                }

                // Default to textbox on right side of ROI
                if (!data.handles.textBox.hasMoved) {
                    const defaultCoords = getROITextBoxCoords(
                        eventData.viewport,
                        data.handles
                    );

                    Object.assign(data.handles.textBox, defaultCoords);
                }

                const textBoxAnchorPoints = handles =>
                    _findTextBoxAnchorPoints(handles.start, handles.end);
                const textBoxContent = _createTextBoxContent(
                    context,
                    image.color,
                    data.cachedStats,
                    modality,
                    hasPixelSpacing,
                    this.configuration
                );

                data.unit = _getUnit(modality, this.configuration.showHounsfieldUnits);

                const tooltipText =  `${data.who} (${data.whenStr})` ;

                if((data.active || this.options.showUser) && data.who) {
                    drawLinkedTextBox(
                        context,
                        element,
                        {
                            x: data.handles.end.x - (data.handles.end.x - data.handles.start.x)/2,
                            y: data.handles.end.y - (data.handles.end.y - data.handles.start.y)/2,
                        },
                        tooltipText,
                        data.handles,
                        textBoxAnchorPoints,
                        "white",
                        lineWidth,
                        0,
                        false
                    );
                }

                if(data.textVisible) {
                    drawLinkedTextBox(
                        context,
                        element,
                        data.handles.textBox,
                        textBoxContent,
                        data.handles,
                        textBoxAnchorPoints,
                        //color,
                        "white",
                        lineWidth,
                        10,
                        true
                    );
                }
                cornerstoneTools.textStyle.setFontSize(initFontSize);
                cornerstoneTools.textStyle.setFont(`${initFontSize}px Roboto`);
            }

        });
    }

}
function _getRectangleImageCoordinates(startHandle, endHandle) {
    return {
        left: Math.min(startHandle.x, endHandle.x),
        top: Math.min(startHandle.y, endHandle.y),
        width: Math.abs(startHandle.x - endHandle.x),
        height: Math.abs(startHandle.y - endHandle.y),
    };
}

function _findTextBoxAnchorPoints(startHandle, endHandle) {
    const { left, top, width, height } = _getRectangleImageCoordinates(
        startHandle,
        endHandle
    );

    return [
        {
            // Top middle point of rectangle
            x: left + width / 2,
            y: top,
        },
        {
            // Left middle point of rectangle
            x: left,
            y: top + height / 2,
        },
        {
            // Bottom middle point of rectangle
            x: left + width / 2,
            y: top + height,
        },
        {
            // Right middle point of rectangle
            x: left + width,
            y: top + height / 2,
        },
    ];
}

/**
 *
 *
 * @param {*} area
 * @param {*} hasPixelSpacing
 * @returns {string} The formatted label for showing area
 */
function _formatArea(area, hasPixelSpacing) {
    // This uses Char code 178 for a superscript 2
    const suffix = hasPixelSpacing
        ? ` mm${String.fromCharCode(178)}`
        : ` px${String.fromCharCode(178)}`;

    return `Area: ${numbersWithCommas(area.toFixed(2))}${suffix}`;
}

function _getUnit(modality, showHounsfieldUnits) {
    return modality === 'CT' && showHounsfieldUnits !== false ? 'HU' : '';
}

/**
 * TODO: This is identical to EllipticalROI's same fn
 * TODO: We may want to make this a utility for ROIs with these values?
 *
 * @param {*} context
 * @param {*} isColorImage
 * @param {*} { area, mean, stdDev, min, max, meanStdDevSUV }
 * @param {*} modality
 * @param {*} hasPixelSpacing
 * @param {*} [options={}]
 * @returns {string[]}
 */
function _createTextBoxContent(
    context,
    isColorImage,
    { area = 0, mean = 0, stdDev = 0, min = 0, max = 0, meanStdDevSUV = 0 } = {},
    modality,
    hasPixelSpacing,
    options = {}
) {
    const showMinMax = options.showMinMax || false;
    const textLines = [];

    const otherLines = [];

    if (!isColorImage) {
        const hasStandardUptakeValues = meanStdDevSUV && meanStdDevSUV.mean !== 0;
        const unit = _getUnit(modality, options.showHounsfieldUnits);

        let meanString = `Mean: ${numbersWithCommas(mean.toFixed(2))} ${unit}`;
        const stdDevString = `Std Dev: ${numbersWithCommas(
            stdDev.toFixed(2)
        )} ${unit}`;

        // If this image has SUV values to display, concatenate them to the text line
        if (hasStandardUptakeValues) {
            const SUVtext = ' SUV: ';

            const meanSuvString = `${SUVtext}${numbersWithCommas(
                meanStdDevSUV.mean.toFixed(2)
            )}`;
            const stdDevSuvString = `${SUVtext}${numbersWithCommas(
                meanStdDevSUV.stdDev.toFixed(2)
            )}`;

            const targetStringLength = Math.floor(
                context.measureText(`${stdDevString}     `).width
            );

            while (context.measureText(meanString).width < targetStringLength) {
                meanString += ' ';
            }

            otherLines.push(`${meanString}${meanSuvString}`);
            otherLines.push(`${stdDevString}     ${stdDevSuvString}`);
        } else {
            otherLines.push(`${meanString}`);
            otherLines.push(`${stdDevString}`);
        }

        if (showMinMax) {
            let minString = `Min: ${min} ${unit}`;
            const maxString = `Max: ${max} ${unit}`;
            const targetStringLength = hasStandardUptakeValues
                ? Math.floor(context.measureText(`${stdDevString}     `).width)
                : Math.floor(context.measureText(`${meanString}     `).width);

            while (context.measureText(minString).width < targetStringLength) {
                minString += ' ';
            }

            otherLines.push(`${minString}${maxString}`);
        }
    }

    textLines.push(_formatArea(area, hasPixelSpacing));
    otherLines.forEach(x => textLines.push(x));

    return textLines;
}